import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR } = process.env

const postEmail = async (data) => {
  const result = { error: false }
  try {
    const res = await axios
      .post(`${VUE_APP_TEST_ERROR || VUE_APP_API_URL}/api/email`, data)
    if (res && res.data) {
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  postEmail
}
